import ProfileNameFields from '@components/account/ProfileNameFields';
import ErrorBox from '@components/common/ErrorBox';
import { AccordionStepsActionTypes, AftercareActionTypes, UserInfoActionTypes } from '@state/features/common.types';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import DwFormFieldPhoneWithPrefix from '@ui/formfield/DwFormFieldPhoneWithPrefix';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
const focusOnError = createDecorator();
const AftercareStep1 = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = React.useState([]);
    const [loginEmail, setLoginEmail] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [phone, setPhone] = useState();
    const [phonePrefix, setPhonePrefix] = useState();
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).loginButton;
    const { user: { isAuthenticated }, } = useSelector((state) => state.userInfo);
    useEffect(() => {
        dispatch({
            type: UserInfoActionTypes.FETCH_USERINFO,
        });
    }, []);
    useEffect(() => {
        if (window.loggedin) {
            api.getProfile().then((data) => {
                setFirstName(data.firstName);
                setLastName(data.lastName);
                setPhone(data.phone);
                setPhonePrefix(data.phonePrefix);
                setLoginEmail(data.email);
            });
        }
    }, []);
    useEffect(() => {
        let val = {};
        api.getForm('aftercare-info', val).then((data) => {
            setInitialValues(val);
            const orderedData = Object.assign({}, data);
            orderedData.country.options.sort((a, b) => {
                if (a.value && b.value) {
                    const A = a.label.toUpperCase();
                    const B = b.label.toUpperCase();
                    return A.localeCompare(B);
                }
            });
            setFormdef(orderedData);
        });
    }, []);
    const onSubmit = async (values) => {
        setErrors([]);
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        // maker for checking if the user has submitted the first step
        values.started = true;
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        api
            .checkLogin(values)
            .then((data) => {
            if (data.success) {
                if (data.exist && data.hasAvailableLoginMethods) {
                    //check account creato in Store
                    if (data.isCreatedInStore && !data.hasChangedPassword) {
                        if (data.hasSentCompleteProfileEmail) {
                            props.setLoginStep('registeredInStore');
                        }
                        else {
                            props.setLoginStep('registeredInStoreSendEmail');
                        }
                    }
                }
                else {
                    // NON esiste account con questa mail
                    props.setLoginStep('register');
                }
            }
        })
            .catch((e) => {
            setErrors([e]);
        });
        return api
            .aftercareStep1(values, formdef)
            .then((data) => {
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            if (data.success) {
                dispatch({
                    type: AftercareActionTypes.UPDATE_AFTERCARE,
                    payload: values,
                });
                dispatch({
                    type: AccordionStepsActionTypes.NAVIGATE_STEP,
                    payload: 'service',
                });
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
            }
            analytics.aftercareOne('proceed');
        })
            .catch((e) => setErrors([e]));
    };
    const validate = async (values) => {
        if (window.loggedin) {
            values.privacyFlag = true;
        }
        return await formutils.validateForm(values, formdef, 'aftercare-info');
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "aftercare__form" },
        React.createElement(Form, { onSubmit: onSubmit, validate: validate, decorators: [focusOnError], initialValues: initialValues, render: ({ handleSubmit, form, submitting, pristine, values }) => {
                var _a;
                return (React.createElement("form", { onSubmit: handleSubmit },
                    window.loggedin && (React.createElement("div", { className: "wrapper-info mt-32" },
                        React.createElement("div", { className: "row mb-16 aftercare__descriptionTitles" },
                            React.createElement("span", { className: "primary-xs-u col-12 col-md-4" }, t('profile.namesurname')),
                            React.createElement("span", { className: "bold col-8 aftercare__text" },
                                firstName,
                                " ",
                                lastName)),
                        React.createElement("div", { className: "row mb-16 aftercare__descriptionTitles" },
                            React.createElement("span", { className: "primary-xs-u col-12 col-md-4" }, t('profile.email')),
                            React.createElement("span", { className: "bold col-8 aftercare__text" }, loginEmail)))),
                    !window.loggedin && !firstName && !lastName && React.createElement(ProfileNameFields, { formdef: formdef }),
                    !window.loggedin && !loginEmail && (React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-12" },
                            React.createElement(DwFormField, { def: formdef, name: "email", autocomplete: "email", validTick: true })))),
                    phone ? (React.createElement("div", { className: "aftercare__descriptionTitles row mb-16" },
                        React.createElement("span", { className: "primary-xs-u col-4 " }, t('profile.phonenumber')),
                        React.createElement("span", { className: "bold col-8 aftercare__text" },
                            phonePrefix,
                            " ",
                            phone))) : (React.createElement(React.Fragment, null, !phone && (React.createElement(React.Fragment, null,
                        window.loggedin && (React.createElement("div", { className: "mb-12 mt-24" },
                            React.createElement("span", null, t('profile.additionalinfo')))),
                        React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, hideHelperText: true, uniqueLabel: t('profile.phonenumber') }))))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-12" },
                            React.createElement(DwFormField, { def: formdef, name: "country", autocomplete: "country", type: ((_a = formdef === null || formdef === void 0 ? void 0 : formdef.country) === null || _a === void 0 ? void 0 : _a.options) ? 'select' : 'text' }))),
                    React.createElement(ErrorBox, { errors: errors }),
                    !window.loggedin && (React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-12 mb-40 mt-12" },
                            React.createElement(DwFormField, { def: formdef, name: "privacyFlag", type: "checkbox" })))),
                    showRecaptcha && React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }),
                    React.createElement("div", { className: "row d-none d-sm-flex wrapper-cta" },
                        React.createElement("div", { className: "col-md-6" }, !window.loggedin && (React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--secondary'] }, t('button.proceed')))),
                        React.createElement("div", { className: "col-md-6" }, !window.loggedin ? (React.createElement("a", { href: window.loginUrl, className: "button button--primary login-button", onClick: () => analytics.aftercareOne('login') },
                            React.createElement("span", null, t('login.loginregister')))) : (React.createElement("div", { className: "mt-32" },
                            React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'] }, t('button.proceed'))))))));
            } })));
};
export default AftercareStep1;
